/**
 * internal dependencies
 */
import GetCardGroups from '../../../routes/get-card-groups';
import { ICardGroupInsertUpdate } from '../../../models/cardgroup.interface';

/**
 * Prepares the model data for the card group list api.
 * 
 * @return the api response data that is to be display in table format.
 */
export const getCardGroupListData = async (): Promise<ICardGroupInsertUpdate[]> => {
  try {
    const { body } = await GetCardGroups();

    return body;
  } catch (error) {
    console.error("Error fetching card group list data:", error);
    return [];
  }
};